import { styled } from '@mui/material';
import * as React from 'react';

const LogoWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        marginTop: 0
    }
}));

const Logo = styled('div')({
    width: '255px',
    height: '50px',
    backgroundImage: "url('../../assets/ML-Logo-Horizontal.png')",
    backgroundSize: 'auto 50px',
    backgroundRepeat: 'no-repeat'
});

export const SignupLogo = () => {
    return (
        <LogoWrapper>
            <Logo />
        </LogoWrapper>
    );
};
